"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Day = void 0;
const day_date_1 = require("../value-objects/day-date");
const shift_1 = require("./shift");
class Day {
    constructor(day) {
        this.date = new day_date_1.DayDate(day.date);
        this.shifts = day.shifts.map(ishift => new shift_1.Shift(ishift));
        this.id = day.id;
    }
    static sorted(list) {
        return [...list].sort((a, b) => a.date.compareTo(b.date));
    }
    withShifts(shifts) {
        return new Day({ id: this.id, date: this.date, shifts });
    }
    toString() {
        return this.date.toString();
    }
}
exports.Day = Day;
//# sourceMappingURL=day.js.map